import {Component, Input, Output, OnInit, EventEmitter} from '@angular/core';
import {Topbar} from "../model/topbar";
import {environment} from "../../environments/environment";
import {Location} from "@angular/common";

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  // Contiene il riferimento al corso selezionato
  @Input()
  header: Topbar;

  @Input()
  showNotification = false;

  // Permette di rivedere il video iniziale
  @Output() showIntroVideo = new EventEmitter<boolean>();

  showMenu = false;
  currentLocation = window.location.hash;
  relearnit_base_url = environment.relearnit_base_url;
  isMobile = false;
  username = localStorage.getItem('header')? JSON.parse(localStorage.getItem('header')).username : null;
  firstName = localStorage.getItem('userFirstName')? localStorage.getItem('userFirstName') : null;
  usernameRegex = /^(LOC|loc|Loc|lOc|loC|LOc|lOC|LoC)\-[0-9]+$/;

  constructor(private location: Location) {

  }

  ngOnInit() {
    this.isMobile = this.checkMobile();
  }

  // Change username when "header" is being passed to menu component
  ngOnChanges(){
    this.username = this.header ? this.header.username : this.username;

  }

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  showIntroVideoFunc() {
    this.toggleMenu();
    this.showIntroVideo.emit(true);
  }

  goBack() {
    this.location.back();
  }

  logout(): void {
    localStorage.clear();
  }

  checkMobile(){
    if( navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i))
    return true;
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/menu/menu.component.ts